// frontend/src/components/DesignForm.js
//
// Accessibility preferences panel. Repurposed from the old (unmounted) design
// intake form so it now actually does something: its toggles drive the global
// AccessibilityContext, applying high-contrast / large-font / text-only
// immediately and persisting them across reloads.
import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { useAccessibility } from '../contexts/AccessibilityContext';

const A11Y_OPTIONS = [
  {
    name: 'highContrast',
    label: 'High Contrast Mode',
    hint: 'Black background with high-contrast text and controls.',
  },
  {
    name: 'largeFont',
    label: 'Large Font',
    hint: 'Increase text size across the whole app.',
  },
  {
    name: 'textOnly',
    label: 'Text-Only Mode',
    hint: 'Hide visual output and show text descriptions instead.',
  },
];

function DesignForm({ onClose }) {
  const a11y = useAccessibility();

  return (
    <div>
      <fieldset className="border-0 p-0 m-0">
        <legend className="h6">Accessibility preferences</legend>
        <p className="text-muted small mb-3">
          Changes apply immediately and are saved on this device.
        </p>
        {A11Y_OPTIONS.map((opt) => (
          <Form.Group className="mb-3" key={opt.name}>
            <Form.Check
              type="checkbox"
              id={`a11y-${opt.name}`}
              label={opt.label}
              checked={!!a11y[opt.name]}
              onChange={(e) => a11y.setSetting(opt.name, e.target.checked)}
            />
            <Form.Text className="text-muted">{opt.hint}</Form.Text>
          </Form.Group>
        ))}
      </fieldset>

      {onClose && (
        <div className="d-grid mt-3">
          <Button variant="primary" onClick={onClose}>
            Done
          </Button>
        </div>
      )}
    </div>
  );
}

export default DesignForm;
